import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21v-13a4 4 0 1 0 -4 4h13","key":"svg-0"}],["path",{"d":"M17 16l4 -4l-4 -4","key":"svg-1"}]]

/**
 * IconArrowLoopRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbG9vcC1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMjF2LTEzYTQgNCAwIDEgMCAtNCA0aDEzIiAvPgogIDxwYXRoIGQ9Ik0xNyAxNmw0IC00bC00IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-loop-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLoopRight = createReactComponent('outline', 'arrow-loop-right', 'ArrowLoopRight', __iconNode);

export default IconArrowLoopRight;